<template>
    <span class="input-text">
        <div class="input-text-label main-text-color" v-if="label">
            {{ $t(label) }}
        </div>
        <el-input :value="inputValue" @input="onChange" @change="onChange" :placeholder="placeholder" :disabled="disabled"></el-input>
    </span>
</template>

<script>
import { Input } from 'element-ui'

export default {
    components: {
        [Input.name]: Input, 
    },
    props: {
        disabled: {
            type: Boolean,
            default: false
        },
        label: {
            type: String,
            default: '' 
        },
        placeholder: {
            type: String,
            default: '' 
        },
        inputValue: {
            type: [Number, String]
        }
    },
    methods: {
        onChange (val) {
            const data = {
                value: val,
                component: this.$attrs
            }
            this.$emit('change', data)
        }
    }
};
</script>

<style lang="scss" scoped>
.input-text-label {
    @apply mb-2;
}
[dir="rtl"] .input-text-label {
    @apply ml-3;
}
[dir="ltr"] .input-text-label {
    @apply mr-3;
}
.el-form-item__error {
    @apply pt-4;
}
.input-text {
    @apply relative;
}
</style>